export const USER_SIGNED_IN = "USER_SIGNED_IN";
export const USER_SIGNED_OUT = "USER_SIGNED_OUT";
export const USER_SIGN_IN_ERR = "USER_SIGN_IN_ERR";
export const REFRESHING_TOKEN = "REFRESHING_TOKEN";
export const UPDATE_USER_CREDIT_INFO = "UPDATE_USER_CREDIT_INFO";